import { INITIAL_STATE } from "~/constants";

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "START_NEW_GAME": {
      // Initial variables
      const newState = _.cloneDeep(state);

      // Change values
      newState.isGameActive = true;
      newState.isGameAnimating = false;
      newState.startTime = new Date();
      newState.isEdgesActive = false;
      newState.isPreviewActive = false;

      // Return new state
      return newState;
    }
    case "TOGGLE_EDGES": {
      // Initial variables
      const newState = _.cloneDeep(state);

      // Change state
      newState.isEdgesActive = !newState.isEdgesActive;

      // Return new state
      return newState;
    }
    case "TOGGLE_PREVIEW": {
      // Initial variables
      const newState = _.cloneDeep(state);

      // Change state
      newState.isPreviewActive = !newState.isPreviewActive;

      // Return new state
      return newState;
    }
    case "SUBTRACT_FROM_TIME": {
      // Initial variables
      const newState = _.cloneDeep(state);

      // Change state
      newState.startTime = new Date(newState.startTime.getTime() + action.duration);

      // Return new state
      return newState;
    }
    case "START_ANIMATION": {
      // Initial variables
      const newState = _.cloneDeep(state);

      // Change state
      newState.isGameAnimating = true;

      // Return new state
      return newState;
    }
    case "END_ANIMATION": {
      // Initial variables
      const newState = _.cloneDeep(state);

      // Change state
      newState.isGameAnimating = false;

      // Return new state
      return newState;
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducer/index.js